export default "__VITE_ASSET__CVqhNg1O__"